<template>
  <div>
    <finance-info :detail="detail" :nativeRegisteredAddress="nativeRegisteredAddress" country="Malaysia" />
    <template v-if="detail.businessType == 'COMPANY_INCORPORATION'">
      <shareholders-info class="mt40" :companyMemberList="detail.companyMemberList" :businessType="detail.businessType" country="Malaysia" />
      <extra-info :detail="detail" :nativeRegisteredAddress="nativeRegisteredAddress" country="Malaysia" />
    </template>
  </div>
</template>

<script>
import FinanceInfo from "../common/financeInfo";
import ShareholdersInfo from "../common/shareholdersInfo";
import ExtraInfo from "../common/extraInfo";
export default {
  components: {
    FinanceInfo,
    ShareholdersInfo,
    ExtraInfo,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    nativeRegisteredAddress: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
